// packages
import React, { useCallback, useEffect, useState } from 'react';

import { useAppStore } from 'src/hooks/useAppStore';
import { httpService } from 'src/services/fetch/HttpService';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';
import {
  FeatureFlagConstants,
  ZEE5_LOGOS
} from 'src/utils/constants/utilConstants';
import { getFeatureFlagConfig } from 'src/utils/RemoteConfig';

type Zee5LogoProps = {
  logoType: string;
  alt?: string;
  title?: string;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
};

function Zee5Logo({
  logoType,
  alt = 'Zee5 Logo',
  title = 'Zee5 Logo',
  width = '100%',
  height = 'auto',
  style,
  onClick
}: Zee5LogoProps) {
  const [logo, setLogo] = useState('');

  const fallbackLogo = (type: string) => {
    switch (type) {
      case ZEE5_LOGOS.ZEE5_LOGO:
        return `${process.env.ENV_BASE_ADDRESS}/images/ZEE5_logo.svg?ver=${process.env.APP_VERSION}`;
      case ZEE5_LOGOS.ZEE5_PLEX_LOGO:
        return `${process.env.ENV_BASE_ADDRESS}/images/zee-plex-logo.png?ver=${process.env.APP_VERSION}`;
      case ZEE5_LOGOS.ZEE5_PLACEHOLDER_LOGO:
        return `${process.env.ENV_BASE_ADDRESS}/images/placeholder_ZEE5.svg?ver=${process.env.APP_VERSION}`;
      default:
        return `${process.env.ENV_BASE_ADDRESS}/images/ZEE5_logo.svg?ver=${process.env.APP_VERSION}`;
    }
  };

  const { remoteConfig } = useAppStore();
  const { enabled, payload } = getFeatureFlagConfig(
    remoteConfig,
    FeatureFlagConstants.CONFIG_DYNAMIC_LOGO
  );
  const getLogoUrl = useCallback(async () => {
    try {
      if (enabled) {
        const response = await httpService.fetchApiData({
          url: payload,
          type: HTTP_METHODS.GET,
          noAuthHeaderFlag: true
        });
        const logoUrl = response?.active?.[logoType];
        setLogo(logoUrl || fallbackLogo(logoType));
      } else {
        setLogo(fallbackLogo(logoType));
      }
    } catch (error) {
      setLogo(fallbackLogo(logoType));
    }
  }, [logoType, enabled, payload]);

  useEffect(() => {
    getLogoUrl();
  }, [getLogoUrl]);

  return (
    <>
      {logo && (
        <img
          src={logo}
          alt={alt}
          title={title}
          width={width}
          height={height}
          style={style}
          onClick={onClick}
        />
      )}
    </>
  );
}

export default Zee5Logo;
